function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_367_7169)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M24 12C24 18.6275 18.6276 24 12.0002 24C5.37286 24 0 18.6275 0 12C0 5.37252 5.37286 0 12.0002 0C18.6276 0 24 5.37252 24 12Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.6957 17.0016H16.5733V7.23235C16.5733 6.62836 16.0876 6.12915 15.4706 6.12915H14.1444L12.792 6.91709V8.88694L14.6957 7.74416V17.0016Z",
  fill: "#FFC700"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.1238 17.0016H13.0014V9.53011C13.0014 8.82136 12.437 8.24341 11.7147 8.24341H10.5724L9.24609 9.05746V11.0008L11.1238 9.87151V17.0016Z",
  fill: "#FFC700"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.57821 17.0017H9.46888V11.7758C9.46888 11.027 8.86483 10.4495 8.15608 10.4495H7.02681L5.6875 11.2505V13.1938L7.57821 12.0645V17.0017Z",
  fill: "#FFC700"
}));
var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_367_7169"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "white"
})));
var SvgLogoPrimeiraMao = function SvgLogoPrimeiraMao(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, ["svgRef", "title"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogoPrimeiraMao, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo-primeira-mao.bcb39574.svg";
export { ForwardRef as ReactComponent };